import { useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Location } from 'history';

const useLocationKey = (resolveKey: (location: Location) => string | undefined): string => {
  const { location } = useHistory();
  const prevKeyRef = useRef<string>(location.key ?? '');

  return (prevKeyRef.current = resolveKey(location) ?? prevKeyRef.current);
};

export default useLocationKey;
